import { notifications } from "@mantine/notifications";
import ErrorRounded from "@mui/icons-material/ErrorRounded";

export const setNotification = (
  id: string,
  update: boolean,
  message: string,
  type: "error" | "success",
  loading?: true,
  persist?: true,
  showAsNew?: true
) => {
  const notif = {
    id: type === "error" ? id + "_err" : showAsNew ? `${id + message}` : id,
    title: `${id} ${type === "error" ? "Error" : "Update"}`,
    color: type === "error" ? "incorrect" : "lightblue",
    icon: type === "error" && <ErrorRounded />,
    message,
    loading,
    withCloseButton: true,
    autoClose: persist ? false : 8000,
  };
  type === "error" && notifications.hide(id);
  update ? notifications.update(notif) : notifications.show(notif);
};
